module.exports = __webpack_public_path__ + "static/media/riki.0686b50c.png";